import { useCallback } from 'react';

interface ToastOptions {
  title?: string;
  description?: string;
  color?: 'default' | 'primary' | 'secondary' | 'success' | 'warning' | 'danger';
  duration?: number;
}

export const useToast = () => {
  const toast = useCallback((options: ToastOptions) => {
    // Создаем элемент toast
    const toastElement = document.createElement('div');
    toastElement.className = `fixed top-4 right-4 z-50 p-4 rounded-lg shadow-lg max-w-sm transform transition-all duration-300 translate-x-full ${
      options.color === 'danger'
        ? 'bg-red-500 text-white'
        : options.color === 'success'
          ? 'bg-green-secondary text-white'
          : options.color === 'warning'
            ? 'bg-yellow-500 text-black'
            : 'bg-gray-800 text-white'
    }`;

    toastElement.innerHTML = `
      ${options.title ? `<div class="font-semibold mb-1">${options.title}</div>` : ''}
      ${options.description ? `<div class="text-sm">${options.description}</div>` : ''}
    `;

    document.body.appendChild(toastElement);

    // Анимация появления
    setTimeout(() => {
      toastElement.classList.remove('translate-x-full');
    }, 100);

    // Автоматическое удаление
    const duration = options.duration || 5000;
    setTimeout(() => {
      toastElement.classList.add('translate-x-full');
      setTimeout(() => {
        if (document.body.contains(toastElement)) {
          document.body.removeChild(toastElement);
        }
      }, 300);
    }, duration);

    // Возможность закрыть по клику
    toastElement.addEventListener('click', () => {
      toastElement.classList.add('translate-x-full');
      setTimeout(() => {
        if (document.body.contains(toastElement)) {
          document.body.removeChild(toastElement);
        }
      }, 300);
    });
  }, []);

  return { toast };
};
